export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNDYuODggMTU4LjY5Ij48ZyBpZD0iTGF5ZXJfMiIgZGF0YS1uYW1lPSJMYXllciAyIj48ZyBpZD0iTGF5ZXJfMS0yIiBkYXRhLW5hbWU9IkxheWVyIDEiPjxyZWN0IHg9IjgwLjI3IiB5PSI1NC41MSIgd2lkdGg9IjE3NC42OSIgaGVpZ2h0PSI0OS41IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtNi45NiAxNDEuNzQpIHJvdGF0ZSgtNDUpIi8+PHJlY3QgeD0iLTguMDgiIHk9IjU0LjY4IiB3aWR0aD0iMTc0LjY5IiBoZWlnaHQ9IjQ5LjUiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDc5LjE1IDE5MS42NCkgcm90YXRlKC0xMzUpIi8+PC9nPjwvZz48L3N2Zz4="


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/arrow-down-big.svg
// module id = 274
// module chunks = 0 5 6 14